module.exports = __webpack_public_path__ + "static/media/ship2.a29d0f8e.png";